/**
 * Roteador por fragmento (`#/carteira`, `#/os/113903`).
 *
 * Fragmento, e não caminho, por dois motivos práticos: o aplicativo é servido
 * como arquivo estático (nada de configurar reescrita no nginx para cada rota
 * nova) e o tablet em modo quiosque não tem barra de endereço para voltar —
 * o histórico do navegador basta.
 */

export interface Rota {
  nome: string;
  parametros: Record<string, string>;
  bruta: string;
}

export interface Roteador {
  atual(): Rota;
  ir(caminho: string): void;
  substituir(caminho: string): void;
  aoMudar(ouvinte: (rota: Rota) => void): () => void;
  voltar(): void;
  iniciar(): void;
}

export function criarRoteador(padrao = '/carteira'): Roteador {
  const ouvintes = new Set<(r: Rota) => void>();

  const ler = (): Rota => {
    const bruta = location.hash.replace(/^#/, '') || padrao;
    const partes = bruta.split('/').filter(Boolean);
    const nome = partes[0] ?? 'carteira';
    const parametros: Record<string, string> = {};
    if (partes[1]) parametros['id'] = decodeURIComponent(partes[1]);
    if (partes[2]) parametros['aba'] = decodeURIComponent(partes[2]);
    const consulta = bruta.includes('?') ? bruta.slice(bruta.indexOf('?') + 1) : '';
    for (const [k, v] of new URLSearchParams(consulta)) parametros[k] = v;
    return { nome: nome.split('?')[0] ?? 'carteira', parametros, bruta };
  };

  const avisar = (): void => {
    const r = ler();
    for (const o of ouvintes) o(r);
  };

  return {
    atual: ler,
    ir(caminho) {
      const alvo = caminho.startsWith('/') ? caminho : `/${caminho}`;
      if (location.hash === `#${alvo}`) avisar();
      else location.hash = alvo;
    },
    substituir(caminho) {
      const alvo = caminho.startsWith('/') ? caminho : `/${caminho}`;
      history.replaceState(null, '', `#${alvo}`);
      avisar();
    },
    aoMudar(ouvinte) {
      ouvintes.add(ouvinte);
      return () => ouvintes.delete(ouvinte);
    },
    voltar() {
      history.back();
    },
    iniciar() {
      addEventListener('hashchange', avisar);
      if (!location.hash) history.replaceState(null, '', `#${padrao}`);
      avisar();
    },
  };
}
